import { render, staticRenderFns } from "./CampaignStatisticsChart.vue?vue&type=template&id=319f65d9&scoped=true&"
import script from "./CampaignStatisticsChart.vue?vue&type=script&lang=ts&"
export * from "./CampaignStatisticsChart.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignStatisticsChart.vue?vue&type=style&index=0&id=319f65d9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319f65d9",
  null
  
)

export default component.exports